<template>
    <div class="inline">
        <select class="timeselect" v-model="hours" @change="change()">
            <option v-for="(item, key) in hours_list" :key="key" :value="item">{{ item }}</option>
        </select>
        <select class="timeselect" v-model="minutes" @change="change()">
            <option v-for="(item, key) in minutes_list" :key="key" :value="item">{{ item }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['value', 'id'],
        data () {
            return {
                hours: this.value ? this.value.split(':')[0] : null,
                minutes: this.value ? this.value.split(':')[1] : null,
                minutes_list: ['00','15','30','45'],
                hours_list: []
            }
        },
        methods: {
            change () {
                if (!this.hours) this.hours = '00'
                if (!this.minutes) this.minutes = '00'
                let time = this.hours + ':' + this.minutes
                this.$emit('update:value', time)
                this.$emit('selectUpdate', {id: this.id, data: time})
            },
            setItems () {
                let result = []
                for (let i = 0; i <= 24; i++) {
                    let time = i
                    if (i < 10) time = '0' + time
                    result.push(time)
                }
                this.hours_list = result

            }
        },
        created () {
            this.setItems()
        }
    }
</script>

<style lang="scss">
    .timeselect {
        padding: 0 0.6rem;
        border: 1px solid #cccccc;
        background: #f3f3f3;
        line-height: 2.6rem;
        height: 2.6rem;
        width: 3.9rem;
        & + .timeselect {
            border-left:0;
        }
    }
</style>